import Component from "../classes/Component";
import {$dom} from "../helpers/dom";
import {$events} from "../helpers/events";
import variables from "../variables";

const {hasClass, getAll, removeClass, get, addClass} = $dom

const dropdownGroupSelector = '.js-header-top-dropdown-group'
const changeCountrySelector = '.js-change-country-dropdown-button'
const leaveCountrySelector = '.js-leave-country-dropdown-button'

export default function () {
    const handleClick = () => {
        const firstLayout = get('.'+variables.classNames.visible, dropdownGroupSelector)
        const secondLayout = get('.'+variables.classNames.hidden, dropdownGroupSelector)

        if (hasClass(firstLayout, variables.classNames.visible)) {
            addClass(firstLayout, variables.classNames.hidden)
            removeClass(firstLayout, variables.classNames.visible)
            addClass(secondLayout, variables.classNames.visible)
            removeClass(secondLayout, variables.classNames.hidden)
        } else {
            addClass(secondLayout, variables.classNames.hidden)
            removeClass(secondLayout, variables.classNames.visible)
            addClass(firstLayout, variables.classNames.visible)
            removeClass(firstLayout, variables.classNames.hidden)
        }
    }

    return new Component({
        name: 'changeCountry',
        requiredTargets: [dropdownGroupSelector, changeCountrySelector, leaveCountrySelector],
        onInit() {
            $events.delegate.on('click', [changeCountrySelector, leaveCountrySelector], handleClick)
        },
        onDestroy() {
            $events.delegate.off('click', [changeCountrySelector, leaveCountrySelector], handleClick)
        },
    })

}